export const ACCESS_TOKEN: string = "accessToken";
export const REDIRECT_FLOW: string = "redirectFlow";
export const REFRESH_TOKEN: string = "refreshToken";
export const CHECKED_LIST: string = "checkedList";
export const LOGIN: string = "login";

type LicenseStatus = {
  DELETED: string;
  PENDING_PAYMENT: string;
  ACTIVE: string;
  EXPIRED: string;
  SUSPENDED: string;
};

export const licenseStatus: LicenseStatus = {
  DELETED: "DELETED",
  PENDING_PAYMENT: "PENDING_PAYMENT",
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  SUSPENDED: "SUSPENDED"
} as const;

type TreeElementTypes = {
  root: string;
  project: string;
  group: string;
  dataSource: string;
  flow: string;
  script: string;
  component: string;
  projectuser: string;
  user: string;
  api: string;
  connection: string;
  report: string;
  graphql: string;
  crawler: string;
};

export const treeElementTypes: TreeElementTypes = {
  root: "ROOT",
  project: "PROJECT",
  group: "GROUP",
  dataSource: "DATASOURCE",
  flow: "FLOW",
  script: "SCRIPT",
  component: "COMPONENT",
  projectuser: "USERVARIABLE",
  user: "VARIABLE",
  api: "API",
  connection: "CONNECTION",
  report: "REPORT",
  graphql: "GRAPHQL",
  crawler: "CRAWLER"
} as const;

export const attrColumnNameForDOMElement: string = "data-column-name";
export const maxLengthFileName: number = 255;
export const maxLengthLimitCharacters: number = 200;
export const maxLengthValueTableCell: number = 255;

type BoardType = {
  label: string;
  value: string;
};

export const boardTypes: readonly BoardType[] = [
  { label: "Default", value: "DEFAULT" },
  { label: "Automation", value: "AUTOMATION" }
] as const;

export const EMAIL_MAX_LENGTH: number = 40;

export const PASSWORD_MIN_LENGTH: number = 8;
export const PASSWORD_MAX_LENGTH: number = 20;

export const INVALID_DOMAINS: readonly string[] = [
  "@gmail.",
  "@yahoo.",
  "@hotmail.",
  "@live.",
  "@aol.",
  "@outlook."
] as const;

export const VALIDATE_COMPANY_EMAIL: boolean = false;
